import { Map } from 'immutable';
export function getModalTrigger(state) {
  var modalOptions = state.getIn(['modal', 'options']) || Map();
  return modalOptions.get('modalTrigger');
}